<!-- <p>submit-gyan works!</p> -->
<div *ngIf="!isLoading && !isMobile" class="highlighted-text advance-gyan-text">
    Enter your Gyan research query and specify any number of sources in the categories below. Specify your query as a hierarchy of topics if you want the results hierarchically
    organized into "chapters".

    <!-- Gyan is going to produce an explainable analysis and knowledge graphs, with additional content discovery, based on your specified sources including current content from the
    internet. This may take a few minutes. -->
</div>
<div *ngIf="!isLoading && isMobile" class="d-flex justify-content-end">
    <div class="info-button-mobile cursor-pointer" (click)="displaytooltipMobile()" clickOutside (clickOutside)="hideTooltip()"></div>
</div>
<div class="form-height d-flex justify-content-center" *ngIf="isLoading">
    <div class="loader-class"><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /><span>Please wait</span></div>
</div>
<div *ngIf="displayTooltip" class="tooltip-gyan">
    <span>
        {{ advancedGyanMessage }}
    </span>
</div>
<div *ngIf="!isLoading">
    <!-- <div class="input-group pb-1r">
        <input
            type="text"
            class="form-control text-box-size shadow-sm"
            placeholder="Type your query"
            autofocus="autofocus"
            [ngModel]="searchStr"
            (ngModelChange)="searchStringChange($event)"
            [attr.id]="'gyan-name-textbox'"
            [attr.data-test]="'gyan-name-textbox'"
        />
    </div> -->
    <!-- <hr /> -->
    <div class="form-height accordion-div" [ngClass]="{ 'pl-1r': isMobile }">
        <ng-scrollbar visibility="hover" [pointerEventsDisabled]="true">
            <accordion [isAnimated]="true" [closeOthers]="false">
                <!-- Topic Outline -->
                <accordion-group
                    heading="Topic Outline"
                    [isOpen]="true"
                    #accordionTopicOutline
                    [ngClass]="{
                        accordionactive: accordionTopicOutline?.isOpen,
                        accordionNotactive: !accordionTopicOutline?.isOpen,
                    }"
                >
                    <span accordion-heading>
                        <fa-icon
                            class="float-end"
                            [ngClass]="accordionTopicOutline?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                            [icon]="accordionTopicOutline?.isOpen ? faAngleUp : faAngleDown"
                        ></fa-icon>
                    </span>
                    <div class="topic-outline-form">
                        <!-- outline form-->
                        <app-topic-form></app-topic-form>
                    </div>
                </accordion-group>
                <!-- Gyan Knowledge Store-->
                <accordion-group
                    heading="Knowledge Stores"
                    *ngIf="GyanKnowledgeStorePermission"
                    [isOpen]="false"
                    #accordionknowledge
                    [ngClass]="{
                        accordionactive: accordionknowledge?.isOpen,
                        accordionNotactive: !accordionknowledge?.isOpen,
                        'knowledge-store': !isMobile,
                        'knowledge-store-mobile': isMobile,
                    }"
                    [attr.id]="'accordion-gyan-knowledge-store'"
                    [attr.data-test]="'accordion-gyan-knowledge-store'"
                >
                    <span accordion-heading>
                        <fa-icon
                            class="float-end"
                            [ngClass]="accordionknowledge?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                            [icon]="accordionknowledge?.isOpen ? faAngleUp : faAngleDown"
                        ></fa-icon>
                    </span>
                    <div class="gyan-knowledge-store">
                        <app-gyan-knowledge-store [flagFromSubmitGyan]="flagValue" (sendCheckedListGKS)="getCheckedItemListGKS()"></app-gyan-knowledge-store>
                    </div>
                </accordion-group>
                <!-- My Knowledge Store -->
                <accordion-group
                    heading="My Content"
                    [isOpen]="false"
                    *ngIf="MyKnowledgeStorePermission"
                    #Gyanaccordionknowledge
                    [ngClass]="{
                        accordionactive: Gyanaccordionknowledge?.isOpen,
                        accordionNotactive: !Gyanaccordionknowledge?.isOpen,
                        'my-knowledge-store': !isMobile,
                        'my-knowledge-store-mobile': isMobile,
                    }"
                    [attr.id]="'accordion-my-knowledge-store'"
                    [attr.data-test]="'accordion-my-knowledge-store'"
                >
                    <span accordion-heading>
                        <fa-icon
                            class="float-end"
                            [ngClass]="Gyanaccordionknowledge?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                            [icon]="Gyanaccordionknowledge?.isOpen ? faAngleUp : faAngleDown"
                        ></fa-icon>
                    </span>
                    <div class="my-knowledge-store">
                        <app-my-knowledge-store [flagFromSubmitGyan]="flagValue" (sendCheckedListMKS)="getCheckedItemListMKS()"></app-my-knowledge-store>
                    </div>
                </accordion-group>
                <accordion-group
                    heading="Web"
                    [isOpen]="false"
                    *ngIf="WebSourcePermission"
                    #accordionwebsource
                    [ngClass]="{ accordionactive: accordionwebsource?.isOpen, accordionNotactive: !accordionwebsource?.isOpen }"
                    [attr.id]="'accordion-web'"
                    [attr.data-test]="'accordion-web'"
                >
                    <span accordion-heading>
                        <fa-icon
                            class="float-end"
                            [ngClass]="accordionwebsource?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                            [icon]="accordionwebsource?.isOpen ? faAngleUp : faAngleDown"
                        ></fa-icon>
                    </span>
                    <div>
                        <!-- <div class="font-12">
                            <label>
                                <input type="checkbox" [(ngModel)]="google" (change)="selectedWeb('https://www.google.com', $event)" /><span class="pl-5px">Google</span>
                            </label>
                        </div> -->
                        <div class="g-font-12 mb-2">
                            <label class="checkbox-label">
                                <input type="checkbox" [(ngModel)]="google" (change)="selectedWeb('https://www.google.com', $event)" />
                                <span class="pl-5px">Google</span>
                            </label>
                        </div>

                        <div>
                            <div class="font-12 mb-2">
                                <span class="font-weight-600" title="set sources of your preferences">Preferred Sources</span><span class="pl-5px"></span>
                            </div>
                            <div class="row d-flex mb-2 pl-3">
                                <input
                                    *ngIf="!isMobile"
                                    type="text"
                                    [(ngModel)]="webURL"
                                    class="form-control h-25 ml-2 website-text-box"
                                    [ngClass]="{ 'web-url': !isMobile, 'web-url-mobile': isMobile }"
                                    placeholder="'http://abc.com' or 'https://abc.com'"
                                    (keydown.enter)="addWebURLArray()"
                                    autofocus
                                    [attr.id]="'preferred-sources-textbox'"
                                    [attr.data-test]="'preferred-sources-textbox'"
                                />
                                <input
                                    *ngIf="isMobile"
                                    type="text"
                                    [(ngModel)]="webURL"
                                    class="form-control h-25 ml-2 website-text-box"
                                    [ngClass]="{ 'web-url': !isMobile, 'web-url-mobile': isMobile }"
                                    placeholder="'http://abc.com' or 'https://abc.com'"
                                    autofocus
                                    [attr.id]="'preferred-sources-textbox'"
                                    [attr.data-test]="'preferred-sources-textbox'"
                                />
                                <button *ngIf="isMobile" type="button" class="add-icon position-add" (click)="addWebURLArray()"></button>
                            </div>
                            <!-- <div class="example-text">for ex "http://abc.com" or "https://abc.com"</div> -->
                            <div class="row pl-3">
                                <div *ngFor="let itm of webURLArray; let i = index">
                                    <div class="pl-3 cursor-pointer font-12 dynamic-width" (click)="editWebURL(itm)">
                                        {{ itm }}
                                        <button type="button" class="btn-close font-9" (click)="removeWebURL(itm)"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <div class="font-12 mb-2">
                                <span class="font-weight-600" title="provide sources you would want us to skip">Ignore Sources</span><span class="pl-5px"></span>
                            </div>
                            <div class="row d-flex mb-2 pl-3">
                                <input
                                    *ngIf="!isMobile"
                                    type="text"
                                    [(ngModel)]="IgnorewebURL"
                                    class="form-control h-25 ml-2 website-text-box"
                                    [ngClass]="{ 'web-url': !isMobile, 'web-url-mobile': isMobile }"
                                    placeholder="'http://abc.com' or 'https://abc.com'"
                                    (keydown.enter)="IgnoreWebURLArray()"
                                    autofocus
                                    [attr.id]="'ignore-sources-textbox'"
                                    [attr.data-test]="'ignore-sources-textbox'"
                                />
                                <input
                                    *ngIf="isMobile"
                                    type="text"
                                    [(ngModel)]="IgnorewebURL"
                                    class="form-control h-25 ml-2 website-text-box"
                                    [ngClass]="{ 'web-url': !isMobile, 'web-url-mobile': isMobile }"
                                    placeholder="'http://abc.com' or 'https://abc.com'"
                                    autofocus
                                    [attr.id]="'ignore-sources-textbox'"
                                    [attr.data-test]="'ignore-sources-textbox'"
                                />
                                <button *ngIf="isMobile" type="button" class="add-icon position-add" (click)="IgnoreWebURLArray()"></button>
                            </div>
                            <!-- <div class="example-text">for ex "http://abc.com" or "https://abc.com"</div> -->
                            <div class="row pl-3">
                                <div *ngFor="let itm of ignorewebURLArray; let i = index">
                                    <div class="pl-3 cursor-pointer font-12 dynamic-width" (click)="editIgnoreWebURL(itm)">
                                        {{ itm }}
                                        <button type="button" class="btn-close font-9" (click)="removeIgnoreWebURL(itm)"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </accordion-group>

                <accordion-group
                    heading="Advanced Settings"
                    [isOpen]="false"
                    #accordionSlider
                    [ngClass]="{ accordionactive: accordionSlider?.isOpen, accordionNotactive: !accordionSlider?.isOpen }"
                    [attr.id]="'accordion-advanced-settings'"
                    [attr.data-test]="'accordion-advanced-settings'"
                >
                    <span accordion-heading>
                        <fa-icon
                            class="float-end"
                            [ngClass]="accordionSlider?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                            [icon]="accordionSlider?.isOpen ? faAngleUp : faAngleDown"
                        ></fa-icon>
                    </span>
                    <div class="pb-3 font-12 font-weight-600">How many articles would you like to have in your Gyan run?</div>
                    <div [ngStyle]="isMobile ? { width: '100%' } : { width: '25%' }" class="custom-slider">
                        <ngx-slider [(value)]="value" [options]="options" (valueChange)="onChangeSlider($event)"></ngx-slider>
                    </div>
                </accordion-group>
            </accordion>
        </ng-scrollbar>
    </div>
    <div class="d-flex justify-content-end" [ngClass]="{ 'submit-button': !isMobile, 'submit-button-mobile': isMobile }">
        <button
            type="submit"
            class="btn btn-save-draft btn-primary mr-3 cursor-pointer"
            [ngClass]="{ 'w-10': !isMobile, 'w-30': isMobile, disabledDiv: searchStr === '' }"
            (click)="opensaveDraftModal()"
            [attr.id]="'save-draft'"
            [attr.data-test]="'save-draft'"
        >
            Save Draft
        </button>
        <button
            type="submit"
            class="btn-custom btn-primary btn-custom-tags mr-3 cursor-pointer"
            [ngClass]="{ 'w-10': !isMobile, 'w-30': isMobile, disabledDiv: searchStr === '' || !disableSubmit }"
            (click)="SubmitGyan()"
            [attr.id]="'submit-gyan'"
            [attr.data-test]="'submit-gyan'"
        >
            Submit
        </button>
    </div>
</div>

<ng-template #saveDraftModal let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">Save Draft</div>
        <div type="button" class="gyan-popup-close" aria-label="Close" (click)="modal.dismiss('Cross click')" [attr.id]="'save-draft-close'" [attr.data-test]="'save-draft-close'">
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body">
        <div>
            <div class="my-3 px-0">
                <!-- <label class="inputtitle">Folder Name</label> -->
                <div class="form-group">
                    <input
                        type="text"
                        [(ngModel)]="draftname"
                        placeholder="Enter Draft Name"
                        class="form-control forminput"
                        [attr.id]="'draft-name'"
                        [attr.data-test]="'draft-name'"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer btn-footer justify-content-end">
        <button
            type="button"
            class="btn modalactionbtnconfirm"
            [ngClass]="{ disabledDiv: isDraftNameEmpty() }"
            [attr.id]="'save-draft'"
            [attr.data-test]="'save-draft'"
            (click)="saveDraft()"
        >
            Save
        </button>
        <button type="button" class="btn modalactioncancel" [attr.id]="'cancel-draft'" [attr.data-test]="'cancel-draft'" (click)="cancelDraft()">Cancel</button>
    </div>
</ng-template>
